export default "__VITE_ASSET__d149c006__"